export const ligas = [
				{
					"nombre": "Catálogo de Especialidades de Contratistas",
					"icono":"DatosContactoUnidad.png",
					"formatos": [
						{
							// "nombre": "Las personas físicas y morales interesadas.",
							// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
							// "html": "./Transparencia/htm/a69_f13_SC.htm"
						}
					],
						 "url" : "/interes/CATALOGO CONTRATISTAS2025.pdf"
				},
				{
				"nombre": "Catálogo de Especialidades de Proveedores",
				"icono":"DatosContactoUnidad.png",
				"formatos": [
					{
						// "nombre": "Las personas físicas y morales interesadas.",
						// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
						// "html": "./Transparencia/htm/a69_f13_SC.htm"
					}
				],
				"url" : "/interes/CATÁLOGO DE ESPECIALIDADES PROVEEDORES2025.pdf"
				},

{
			"nombre": "Consejeros de la Secretaría para el PROTOCOLO CERO.",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			 "url" : "/interes/CANDIDATOS_PROTOCOLO_CERO.pdf"
			},

			{
			"nombre": "Convocatoria personas consejeras",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			 "url" : "/interes/con_per_consejeras.pdf"
			},

			{
			"nombre": "Diagnóstico Clima Laboral",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
					{
					// "nombre": "Las personas físicas y morales interesadas.",
			      // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
					}
				],
				"url" : "/interes/Infografía_Contraloría.pdf"
		    },

	{
						"nombre": "Manifiesto Servidores Públicos",
						"icono":"DatosContactoUnidad.png",
						"formatos": [
							{
								// "nombre": "Las personas físicas y morales interesadas.",
								// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
								// "html": "./Transparencia/htm/a69_f13_SC.htm"
							}
						],
						"url" : "/interes/MANIFIESTO SERVIDORES PUBLICOS.pdf"
					},

					{
						"nombre": "Manifiesto Personas Particulares",
						"icono":"DatosContactoUnidad.png",
						"formatos": [
							{
								// "nombre": "Las personas físicas y morales interesadas.",
								// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
								// "html": "./Transparencia/htm/a69_f13_SC.htm"
							}
						],
						"url" : "/interes/MANIFIESTO PERSONAS PARTICULARES.pdf"
				},


		{
						"nombre": " Padrón de Empresas Íntegras",
						"icono":"DatosContactoUnidad.png",
						"formatos": [
							{
								// "nombre": "Las personas físicas y morales interesadas.",
								// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
								// "html": "./Transparencia/htm/a69_f13_SC.htm"
							}
						],
						"url" : "/interes/RELACION_EMPRESAS_INTEGRAS_19DIC2024.pdf"
					},

	  
		{
				"nombre": "Programa Anual de Adquisiciones 2025 Secretaría de Contraloría",
				"icono":"DatosContactoUnidad.png",
				"formatos": [
					{
						// "nombre": "Las personas físicas y morales interesadas.",
						// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
						// "html": "./Transparencia/htm/a69_f13_SC.htm"
					}
				],
				 "url" : "/interes/PROGRAMA ANUAL DE ADQUISICIONES 2025 SECRETARIA DE CONTRALORIA.pdf"
			},


			// "nombre" : "Procedimientos de Contratación",
            //    //     "link" : "/Procedimiento",

			   {
				"nombre": "Procedimientos de Contratación",
				"icono":"DatosContactoUnidad.png",
				"formatos": [
					{
						// "nombre": "Las personas físicas y morales interesadas.",
						// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
						// "html": "./Transparencia/htm/a69_f13_SC.htm"
					}
				],
				 "url" : "/Procedimiento"
				},
		   
			  {
				"nombre": "Política Estatal Anticorrupción de Hidalgo",
				"icono":"DatosContactoUnidad.png",
				"formatos": [
					{
						// "nombre": "Las personas físicas y morales interesadas.",
						// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
						// "html": "./Transparencia/htm/a69_f13_SC.htm"
					}
				],
				 "url" : "/interes/PoliticaEstatalAnticorrupcionDeHidalgo.pdf"
				},
				
				{
					"nombre": "Reglamento Interior de la Secretaría de Contraloría",
					"icono":"DatosContactoUnidad.png",
					"formatos": [
						{
							// "nombre": "Las personas físicas y morales interesadas.",
							// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
							// "html": "./Transparencia/htm/a69_f13_SC.htm"
						}
					],
					"url" : "/interes/RI_SC.pdf"
				 },

				 {
					"nombre": "Oficina Virtual de Revisión de Bases",
					"icono":"DatosContactoUnidad.png",
					"formatos": [
						{
							// "nombre": "Las personas físicas y morales interesadas.",
							// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
							// "html": "./Transparencia/htm/a69_f13_SC.htm"
						}
					],
					"url" : "https://esit.hidalgo.gob.mx/eSIT/oficinaVirtual/P1_mov_padron/oficina_virtual/c_oficina_virtual_ss.jsp?cve_ruts=SC/SC/18"
				 },


				  {
				"nombre": "Servidores Públicos Sancionados",
				"icono":"DatosContactoUnidad.png",
				"formatos": [
					{
						// "nombre": "Las personas físicas y morales interesadas.",
						// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
						// "html": "./Transparencia/htm/a69_f13_SC.htm"
					}
				],
				 "url" : "/Sancionados"
				},
			
	 					
				
					// {
					// 	"nombre": "Participación Ciudadana",
					// 	"icono":"DatosContactoUnidad.png",
					// 	"formatos": [
					// 		{
					// 			// "nombre": "Las personas físicas y morales interesadas.",
					// 			// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// 			// "html": "./Transparencia/htm/a69_f13_SC.htm"
					// 		}
					// 	],
					// 	"url" : "/interes/participacion.jpeg"
					// },
					// {
					// 	"nombre": "Participación Ciudadana",
					// 	"icono":"DatosContactoUnidad.png",
					// 	"formatos": [
					// 		{
					// 			// "nombre": "Las personas físicas y morales interesadas.",
					// 			// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// 			// "html": "./Transparencia/htm/a69_f13_SC.htm"
					// 		}
					// 	],
					// 	"url" : "/interes/participacionI.jpeg"
					// },
				
					

						
			

];